import config from "../config/config";

export const getProductInformationUrl = (orgId: string): string => {
  return `${config.projectManagementService.url}/organisations/${orgId}/product-information`;
};

export default getProductInformationUrl;
